export default __webpack_public_path__ + "static/media/icon_newsletter.c43e0646.svg";